import { makeStyles } from "@material-ui/core";
export const HeaderModalStyle = makeStyles((theme) => ({
    headerModal: {
        width: "100%",
        padding: "1px 15px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
}));